import { FilterFields } from 'shared/mui/Filter/FilterFields/FilterFields';

import { useApiClientsListFilterFields } from './hooks/useApiClientsListFilterFields';

export const ApiClientsListFilter: React.FC = () => {
  const fields = useApiClientsListFilterFields();

  return <FilterFields fields={fields} />;
};
